import type { Locales } from 'app/helpers/createLocalesContext';
import { translation } from 'app/helpers/createLocalesContext';
import { Values, Errors } from './types';
import { useFieldValidation } from './useServerValidation';

const useLoginValidation = (values: Values, locales: Locales): [boolean, boolean, Errors] => {
  const [isLoginValidOnServer, isLoginValidating, loginErrors] = useFieldValidation(values, 'login');

  const isInFormat = /^[A-Za-z0-9]{3,12}$/.test(values.login);
  const errors = loginErrors.login || [];

  if (!isInFormat) errors.push(translation(locales, 'login.format_hint'));

  return [isLoginValidOnServer && isInFormat, isLoginValidating, { login: errors }];
};

export default useLoginValidation;
